import { getPlaceItOfferMessages } from "_graphql/place-it/queries/offers.place-it";

import { Offer_messages } from "_graphql/queries/__generated__/Offer_messages";
import { Offer_messagesVariables } from "_graphql/queries/__generated__/Offer_messages";
import { placeItClient } from "_graphql";
import { useQuery } from "@apollo/client";

export const usePlaceItOfferMessages = (variables: Offer_messagesVariables) => {
  const { data, ...rest } = useQuery<Offer_messages, Offer_messagesVariables>(
    getPlaceItOfferMessages,
    {
      variables,
      client: placeItClient,
      fetchPolicy: "network-only",
      pollInterval: 1000 * 15,
    }
  );

  return { offers: data?.offer_messages || [], ...rest };
};
